import $ from 'jquery';
import { post } from 'common/utils/xhr';
import EmailSubscriptionService from '@99designs/email-subscription-service';

export default function() {
    $('[data-email-collector]').each(function(){
        initCollector(this);
    });
}

function initCollector(parentObject) {
    $(parentObject).find('[data-email-collector-form]').submit(function(e) {
        e.preventDefault();

        const genericError = $(parentObject).find('[data-email-collector-error-translated]');
        const action = $(this).attr('action');
        const formData = $(this).serializeArray().reduce(function(obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        const service = new EmailSubscriptionService(window.analytics);

        service.subscribe({
            email: formData['email_subscription[email_address]'],
            acquisition_source: formData['email_subscription[acquisition_source]'],
            custom_data: {
                is_designer: formData['email_subscription[custom_data][is_designer]'],
                industry: formData['industry']
            }
        })
        .then((res) => {
            handleSuccess(res, parentObject);
        })
        .catch((res) => {
            const errorMessages = res.errors || genericError;
            handleError(errorMessages, parentObject);
        });
    });
}

function handleSuccess(post, parentObject) {
    var collector = $(parentObject).find('[data-email-collector-collect]'),
        collectorError = $(parentObject).find('[data-email-collector-error]'),
        collectorSent = $(parentObject).find('[data-email-collector-sent]');

    // Hide existing error on post
    collector.attr('data-hidden', true);

    // Hide collector, show sent message
    collectorSent.removeAttr('data-hidden');
    collectorError.attr('data-hidden', true);
}


function handleError(errors, parentObject) {
    var collectorWidth = $(parentObject).find('[data-email-collector-collect-fields]').width() + 'px',
        collectorError = $(parentObject).find('[data-email-collector-error]'),
        collectorErrorField = $(parentObject).find('[data-email-collector-error-field]');

    collectorErrorField.html(errors.join('<br>'));
    collectorError.css({ 'width': collectorWidth }).removeAttr('data-hidden');
}



/** WEBPACK FOOTER **
 ** ./js/marketing/components/email-collector.js
 **/